import * as React from 'react';
import { ProtectedPage } from '../genericComponents/Page/ProtectedPage/ProtectedPage';
import { UserRole } from '../../types/UserRole';
import './LoginPage.css';
import { CenterContainer } from './internalComponents/CenterContainer';
import { FormLogin } from './internalComponents/FormLogin';
import { FormRegister } from './internalComponents/FormRegister';
import { ResPasswordForm } from './internalComponents/ResPasswordForm';

export enum Actions {
    LOGIN,
    REGISTER,
    RESET
}

/**
 * ce Composant permet l'affichage de la page de login
 */
export class LoginPage extends React.Component {
    props: {};
    state: {
        action: Actions;
    };

    /**
     *
     * @param {{}} props
     */
    constructor(props: {}) {
        super(props);
        this.state = {
            action: Actions.LOGIN
        };
    }

    render() {
        var content: JSX.Element;
        switch (this.state.action) {
            case Actions.LOGIN:
                content = <FormLogin actionHandler={this.SetAction} />;
                break;
            case Actions.REGISTER:
                content = <FormRegister actionHandler={this.SetAction} />;
                break;
            case Actions.RESET:
                content = <ResPasswordForm actionHandler={this.SetAction} />;
                break;
            default:
                content = <div />;
        }

        return (
            <ProtectedPage
                allowedUsers={[
                    UserRole.USER,
                    UserRole.SUPER_ADMIN,
                    UserRole.SEMI_PRO,
                    UserRole.NOT_LOGED_IN,
                    UserRole.MEMBER,
                    UserRole.ADMIN,
                ]}
            >
                <div className="LoginPageChorinitia container-fluid">
                    <CenterContainer
                        header={[
                            (
                                <div
                                    className="col-6 text-center HeaderElement"
                                    onClick={() => {
                                        this.SetAction(Actions.LOGIN);
                                    }}
                                >
                                    <h4>Se connecter</h4>
                                </div>
                            ),
                            (
                                <div
                                    className="col-6 text-center HeaderElement"
                                    onClick={() => {
                                        this.SetAction(Actions.REGISTER);
                                    }}
                                >
                                    <h4>S'inscrire</h4>
                                </div>
                            )]}
                    >
                        {content}
                    </CenterContainer>
                </div >
            </ProtectedPage >
        );
    }

    private SetAction = (action: Actions) => {
        this.setState({ action: action });
    }
}


// WEBPACK FOOTER //
// ./src/components/LoginPage/LoginPage.tsx